module.exports = __webpack_public_path__ + "static/media/tod.65cb1630.png";